export const excerpt = (text: string, excerptLength: number): string =>
  excerptLength >= text.length ? text : text.substring(0, excerptLength) + '...';
